// @flow
import React from 'react';
import Icon from './Icon';

type Props = {
  size?: 'tiny' | 'small' | 'large'
};

const calculateWidth = size => {
  if (size === 'tiny') return 16;

  return size === 'small' ? 25 : 50;
};

const Loader = ({ size = 'small' }: Props) => (
  <Icon icon="loading-wheel-primary" width={calculateWidth(size)} />
);

export default Loader;
